import { computed, makeObservable, observable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { SickDay } from "../models/SickDay";
import { FieldGroupId } from "../lib/enums";
import { convertFormsToSickDays } from "../utils/formHelpers";
import { FormGetResponse } from "../models/Form";
import { getLatestBasedOnStartDatum } from "../utils/dateHelpers";

class SickDaysStore {
  rootStore: RootStore;
  sickDays: SickDay[] | undefined = undefined;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      sickDays: observable,
      latestSickDays: computed
    });
  }

  get latestSickDays() {
    if(this.sickDays) {
      return getLatestBasedOnStartDatum(this.sickDays)
    }
    return [] as SickDay[];
  }

  setSickDays(newSickDays: SickDay[] | undefined) {
    runInAction(() => {
      this.sickDays = newSickDays ?? [];
    })
  }

  getSickDays = async () => {
    const forms = await this.rootStore.formStore.getFormsByFormId(FieldGroupId.SICKDAYS_FIELD_GROUP_ID);
    this.setSickDays(convertFormsToSickDays(forms as FormGetResponse[]));
  }

}

export default SickDaysStore;
